export default __webpack_public_path__ + "static/media/IATANLogo.97898920.webp";